import { DashboardSkeleton } from '@/components/ui/Skeleton';

/** Shown while a lazy route chunk loads (F-03 code splitting). */
export function RouteLoadingFallback() {
  return (
    <div className="page-content p-6">
      <DashboardSkeleton kpiCount={4} />
    </div>
  );
}
